import {
  JOBPOSTINGAPPLY_FETCHING,
  JOBPOSTINGAPPLY_FAILED,
  JOBPOSTINGAPPLY_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case JOBPOSTINGAPPLY_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case JOBPOSTINGAPPLY_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case JOBPOSTINGAPPLY_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
